import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "react-modal";
import { Spinner } from "reactstrap";
import Swal from "sweetalert2";

import obtieneDatos from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import DevuelveCursos from "../certificados/devuelveCursos";
import DevuelveCertificados from "../certificados/devuelveCertificados";
import seteaCertificado from "./seteaCokieCertificado";
import FormNuevoCertificado2 from "./formNuevoCertificado2";
import FormEditoCertificado2 from "./formEditoCertificado2";
import CargaMasiva from "./CargaMasiva";
import ModalOUR from "./Modal";
import FormEditoCertificadoTitulo from "./formEditoCertificadoTitulo";
import FormNuevoCertificadoTitulos from "./formNuevoCertificadoTitulos";

const LIMITE_POR_PAGINA = 200;

function Certificados() {
  const Usuario = obtieneDatos();
  const navigate = useNavigate();

  const [cursosDisponibles, setCursosDisponibles] = useState([]);
  const [nominaCursantes, setNominaCursantes] = useState([]);

  const [muestroCursos, setMuestroCursos] = useState(false);
  const [muestroNominaCursantesCursos, setMuestroNominaCursantesCursos] =
    useState(false);
  const [veoCargaMasiva, setVeoCargaMasiva] = useState(false);

  const [cursoSeleccionado, setCursoSeleccionado] = useState({});

  const [modalNuevoCertificadoIsOpen, setModalNuevoCertificadoIsOpen] =
    useState(false);
  const [modalEditoCertificadoIsOpen, setModalEditoCertificadoIsOpen] =
    useState(false);
  const [modalCargando, setModalCargando] = useState(false);

  /*
   * PAGINACIÓN DE CURSOS
   */
  const [paginaCursos, setPaginaCursos] = useState(1);
  const [totalPaginasCursos, setTotalPaginasCursos] = useState(1);
  const [totalCursos, setTotalCursos] = useState(0);
  const [traerTodosCursos, setTraerTodosCursos] = useState(false);
  const [haySiguienteCursos, setHaySiguienteCursos] = useState(false);

  /*
   * PAGINACIÓN DE CURSANTES
   */
  const [paginaCursantes, setPaginaCursantes] = useState(1);
  const [totalPaginasCursantes, setTotalPaginasCursantes] = useState(1);
  const [totalCursantes, setTotalCursantes] = useState(0);
  const [traerTodosCursantes, setTraerTodosCursantes] = useState(false);
  const [haySiguienteCursantes, setHaySiguienteCursantes] = useState(false);

  // 1. Obtienes el string del localStorage
  const usuarioString = localStorage.getItem("usuarioSIGEDI");

  // 2. Lo conviertes a un objeto JavaScript
  const usuario = JSON.parse(usuarioString);

  // 3. Ahora sí puedes acceder a sus propiedades
  const niUsuario = usuario?.identificacion;

  console.log("Objeto usuario:", usuario);
  console.log("Identificación:", niUsuario); // Imprimirá "786268"
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(15, 23, 42, 0.72)",
      zIndex: 1000,
    },
    content: {
      inset: "4% 5%",
      border: "none",
      borderRadius: "16px",
      padding: "0",
      overflowY: "auto",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.28)",
    },
  };

  const customStyles2 = {
    content: {
      width: "auto",
      height: "auto",
    },
  };

  useEffect(() => {
    if (!Usuario?.id) {
      Swal.fire({
        icon: "error",
        title: "Acceso no autorizado",
        text: "Debe iniciar sesión para ingresar a esta sección.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        window.location.href = "./";
      });

      return;
    }

    muestraCursosCertificados({
      page: 1,
      todo: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const obtenerMensajeError = (error, mensajeAlternativo) =>
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.response?.data?.Mensaje ||
    mensajeAlternativo;

  const obtenerNumeroHeader = (
    headers,
    nombre,
    valorDefecto = 0
  ) => {
    const valor = headers?.[nombre.toLowerCase()];
    const numero = Number(valor);

    return Number.isFinite(numero)
      ? numero
      : valorDefecto;
  };

  /*
   * TRAE LOS CURSOS.
   * Por defecto trae 200.
   * Con todo=true trae todos.
   */
  const muestraCursosCertificados = async ({
    page = paginaCursos,
    todo = traerTodosCursos,
  } = {}) => {
    setMuestroCursos(false);
    setModalCargando(true);

    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "certificados/consulta/cursosDisponibles/",
    });

    try {
      const body =
        Number(Usuario.destino) === 7 ||
          comprueboPermisos(
            Usuario.funcion,
            "Veo Todo Certificados"
          )
          ? {}
          : {
            destinoCreo: Usuario.destino,
          };

      const response = await client.post(
        `/?page=${page}&limit=${LIMITE_POR_PAGINA}&todo=${todo}`,
        body
      );

      /*
       * Acepta los dos formatos del backend:
       *
       * 1) Array directo:
       *    [ ...registros ]
       *
       * 2) Objeto paginado:
       *    {
       *      registros: [...],
       *      paginacion: {...}
       *    }
       */
      const datos = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.registros)
          ? response.data.registros
          : [];

      const paginacion =
        response?.data?.paginacion || {};

      const totalDesdeHeader = obtenerNumeroHeader(
        response.headers,
        "x-total-count",
        0
      );

      const total =
        Number(paginacion.totalRegistros) ||
        totalDesdeHeader ||
        datos.length;

      const totalPaginasDesdeHeader =
        obtenerNumeroHeader(
          response.headers,
          "x-total-pages",
          0
        );

      const totalPaginas =
        Number(paginacion.totalPaginas) ||
        totalPaginasDesdeHeader ||
        Math.max(Math.ceil(total / LIMITE_POR_PAGINA), 1);

      const paginaActual =
        Number(paginacion.paginaActual) ||
        obtenerNumeroHeader(
          response.headers,
          "x-current-page",
          page
        ) ||
        page;

      /*
       * Esta comprobación permite que "Siguiente" funcione
       * incluso cuando CORS no expone los headers.
       *
       * Si llegaron exactamente 200 registros, suponemos que
       * puede existir otra página. Al abrirla, si llegan menos
       * de 200, el botón se deshabilita.
       */
      const existePaginaSiguiente =
        typeof paginacion.tieneSiguiente === "boolean"
          ? paginacion.tieneSiguiente
          : !todo &&
          (
            paginaActual < totalPaginas ||
            datos.length === LIMITE_POR_PAGINA
          );

      setCursosDisponibles(datos);
      setTotalCursos(total);
      setTotalPaginasCursos(
        Math.max(totalPaginas, paginaActual)
      );
      setPaginaCursos(Math.max(paginaActual, 1));
      setTraerTodosCursos(Boolean(todo));
      setHaySiguienteCursos(existePaginaSiguiente);
    } catch (error) {
      console.error(
        "Error al obtener los cursos:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "No se pudieron cargar los cursos",
        text: obtenerMensajeError(
          error,
          "Ocurrió un error al consultar los cursos disponibles."
        ),
      });
    } finally {
      setModalCargando(false);
      setMuestroCursos(true);
    }
  };

  /*
   * TRAE LOS CURSANTES DEL CURSO.
   * Por defecto trae 200.
   * Con todo=true trae todos.
   */
  const muestraDatosCursosCertificados = async (
    curso,
    {
      page = 1,
      todo = false,
    } = {}
  ) => {
    if (!curso?.nombreCurso) return;

    setCursoSeleccionado(curso);
    setModalCargando(true);

    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "certificados/consulta/cursantesCurso/",
    });

    try {
      const response = await client.post(
        `/${encodeURIComponent(
          curso.nombreCurso
        )}?page=${page}&limit=${LIMITE_POR_PAGINA}&todo=${todo}`
      );

      const datos = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.data?.registros)
          ? response.data.registros
          : [];

      const paginacion =
        response?.data?.paginacion || {};

      const totalDesdeHeader = obtenerNumeroHeader(
        response.headers,
        "x-total-count",
        0
      );

      const total =
        Number(paginacion.totalRegistros) ||
        totalDesdeHeader ||
        datos.length;

      const totalPaginasDesdeHeader =
        obtenerNumeroHeader(
          response.headers,
          "x-total-pages",
          0
        );

      const totalPaginas =
        Number(paginacion.totalPaginas) ||
        totalPaginasDesdeHeader ||
        Math.max(Math.ceil(total / LIMITE_POR_PAGINA), 1);

      const paginaActual =
        Number(paginacion.paginaActual) ||
        obtenerNumeroHeader(
          response.headers,
          "x-current-page",
          page
        ) ||
        page;

      const existePaginaSiguiente =
        typeof paginacion.tieneSiguiente === "boolean"
          ? paginacion.tieneSiguiente
          : !todo &&
          (
            paginaActual < totalPaginas ||
            datos.length === LIMITE_POR_PAGINA
          );

      setNominaCursantes(datos);
      setTotalCursantes(total);
      setTotalPaginasCursantes(
        Math.max(totalPaginas, paginaActual)
      );
      setPaginaCursantes(
        Math.max(paginaActual, 1)
      );
      setTraerTodosCursantes(Boolean(todo));
      setHaySiguienteCursantes(
        existePaginaSiguiente
      );
      setMuestroNominaCursantesCursos(true);
    } catch (error) {
      console.error(
        "Error al obtener los cursantes:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "No se pudo cargar la nómina",
        text: obtenerMensajeError(
          error,
          "Ocurrió un error al consultar los cursantes."
        ),
      });
    } finally {
      setModalCargando(false);
    }
  };

  const cambiarPaginaCursos = async (
    nuevaPagina
  ) => {
    if (
      traerTodosCursos ||
      nuevaPagina < 1 ||
      (
        nuevaPagina > paginaCursos &&
        !haySiguienteCursos
      )
    ) {
      return;
    }

    await muestraCursosCertificados({
      page: nuevaPagina,
      todo: false,
    });
  };

  const cambiarModoCursos = async (todo) => {
    await muestraCursosCertificados({
      page: 1,
      todo,
    });
  };

  const cambiarPaginaCursantes = async (
    nuevaPagina
  ) => {
    if (
      traerTodosCursantes ||
      nuevaPagina < 1 ||
      (
        nuevaPagina > paginaCursantes &&
        !haySiguienteCursantes
      )
    ) {
      return;
    }

    await muestraDatosCursosCertificados(
      cursoSeleccionado,
      {
        page: nuevaPagina,
        todo: false,
      }
    );
  };

  const cambiarModoCursantes = async (todo) => {
    await muestraDatosCursosCertificados(
      cursoSeleccionado,
      {
        page: 1,
        todo,
      }
    );
  };

  const crearCertificadoCurso = () => {
    setModalNuevoCertificadoIsOpen(true);
  };

  const editaCurso = () => {
    if (!cursoSeleccionado?.id) {
      Swal.fire({
        icon: "info",
        title: "Seleccione una certificación",
        text: "Primero debe seleccionar una certificación para editarla.",
      });

      return;
    }

    setModalEditoCertificadoIsOpen(true);
  };


  const cambiaFecha = async () => {
    console.log(
      "ID del curso:",
      cursoSeleccionado?.id
    );

    const resultado = await Swal.fire({
      title: "Cambiar fecha del curso",

      html: `
      <div style="text-align: left;">

        <label 
          for="nuevaFecha" 
          style="
            display: block;
            margin-bottom: 8px;
            font-weight: 600;
          "
        >
          Seleccione la nueva fecha
        </label>

        <input 
          type="date" 
          id="nuevaFecha" 
          class="swal2-input"
          style="
            width: 100%;
            margin: 0;
            box-sizing: border-box;
          "
        />

      </div>
    `,

      showCancelButton: true,

      confirmButtonText: "Cambiar fecha",

      cancelButtonText: "Cancelar",

      reverseButtons: true,

      focusCancel: true,

      preConfirm: () => {

        const fecha =
          document.getElementById("nuevaFecha")?.value;

        if (!fecha) {

          Swal.showValidationMessage(
            "Debe seleccionar una fecha."
          );

          return false;
        }

        return fecha;
      },
    });

    if (!resultado.isConfirmed) {
      return;
    }

    const fechaSeleccionada =
      resultado.value;

    console.log(
      "ID del curso:",
      cursoSeleccionado?.id
    );

    console.log(
      "Nueva fecha:",
      fechaSeleccionada
    );

    try {

      const respuesta = await axios.post(
          "https://wwwp.isepsantafe.net.ar/certificados/cambiaFecha",
          {
            idCurso: cursoSeleccionado.id,
  
            fecha: fechaSeleccionada,

            usuario: niUsuario,
          }
        );
  
          if (respuesta.data.ok === true) {
      await Swal.fire({
        icon: "success",
        title: "Fecha actualizada",
        text: "La fecha del curso fue actualizada correctamente.",
        confirmButtonText: "Aceptar",
      });
    }
  
        console.log("Respuesta:",respuesta.data);



    } catch (error) {

      console.error(
        "Error al cambiar la fecha:",
        error
      );

      await Swal.fire({
        icon: "error",

        title: "No se pudo cambiar la fecha",

        text: obtenerMensajeError(
          error,
          "Ocurrió un error al actualizar la fecha del curso."
        ),
      });
    }
  };




  const volver = () => {
    navigate("/usuarioLogueado");
  };

  const imprimoCertificado = (
    certificadoSeleccionado
  ) => {
    seteaCertificado(certificadoSeleccionado);

    window.open(
      `/imprimeCertificado?ni=${encodeURIComponent(
        certificadoSeleccionado.dniCertificado
      )}&curso=${encodeURIComponent(
        cursoSeleccionado.nombreCurso
      )}`,
      "_blank"
    );
  };

  const desactivaCertificado = async (
    certificadoSeleccionado
  ) => {
    const nombrePersona =
      certificadoSeleccionado?.apellidoNombre ||
      certificadoSeleccionado?.apellido ||
      certificadoSeleccionado?.nombreApellido ||
      certificadoSeleccionado?.nombre_y_apellido ||
      certificadoSeleccionado?.dniCertificado ||
      "el cursante seleccionado";

    const resultado = await Swal.fire({
      icon: "warning",
      title: "¿Eliminar certificado?",
      html: `
        <p style="margin-bottom: 8px;">
          Se desactivará el certificado de
          <strong>${nombrePersona}</strong>.
        </p>
        <p style="color:#b91c1c; margin-bottom:8px;">
          Esta acción quedará registrada.
        </p>
      `,
      input: "textarea",
      inputLabel: "Observación del motivo",
      inputPlaceholder:
        "Escriba el motivo por el cual elimina este certificado...",
      inputAttributes: {
        maxlength: "500",
        "aria-label":
          "Observación del motivo de eliminación",
      },
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
      focusCancel: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showLoaderOnConfirm: true,

      preConfirm: async (observacion) => {
        const observacionLimpia =
          observacion?.trim();

        if (!observacionLimpia) {
          Swal.showValidationMessage(
            "Debe ingresar una observación para eliminar el certificado."
          );

          return false;
        }

        if (observacionLimpia.length < 5) {
          Swal.showValidationMessage(
            "La observación debe tener al menos 5 caracteres."
          );

          return false;
        }

        try {
          await desactivoCertificadoOK(
            certificadoSeleccionado,
            observacionLimpia
          );

          return observacionLimpia;
        } catch (error) {
          console.error(
            "Error al eliminar el certificado:",
            error
          );

          Swal.showValidationMessage(
            obtenerMensajeError(
              error,
              "No se pudo eliminar el certificado."
            )
          );

          return false;
        }
      },
    });

    if (!resultado.isConfirmed) return;

    await Swal.fire({
      icon: "success",
      title: "Certificado eliminado",
      text: "El certificado fue desactivado y la observación quedó registrada.",
      confirmButtonText: "Aceptar",
    });
  };

  const desactivoCertificadoOK = async (
    certificadoSeleccionado,
    observacion
  ) => {
    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "certificados/",
    });

    const response = await client.post(
      `desactivaCertificado?certificadoID=${certificadoSeleccionado.id}`,
      {
        nombreCurso:
          cursoSeleccionado.nombreCurso,
        observacion,
        usuarioID: Usuario.id,
        usuarioDNI: Usuario.identificacion,
      }
    );

    await muestraDatosCursosCertificados(
      cursoSeleccionado,
      {
        page: paginaCursantes,
        todo: traerTodosCursantes,
      }
    );

    return response;
  };

  const vaciarCursantes = async () => {
    if (!cursoSeleccionado?.nombreCurso) {
      return;
    }

    const { value: password } =
      await Swal.fire({
        icon: "warning",
        title: "Confirmación requerida",
        html: `
          <p>
            Está por vaciar todos los cursantes de
            <strong>${cursoSeleccionado.tituloCertificado ||
          cursoSeleccionado.nombreCurso
          }</strong>.
          </p>
          <p style="color:#b91c1c;">
            Esta acción es crítica.
          </p>
        `,
        input: "password",
        inputPlaceholder: "Contraseña",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc3545",
        reverseButtons: true,
        allowOutsideClick: false,

        preConfirm: (value) => {
          if (!value) {
            Swal.showValidationMessage(
              "Debe ingresar la contraseña."
            );

            return false;
          }

          return value;
        },
      });

    if (!password) return;

    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "certificados/",
    });

    try {
      setModalCargando(true);

      await client.post(
        "consulta/vaciarTablaCurso/",
        {
          curso:
            cursoSeleccionado.nombreCurso,
          pass: password,
          usuario: Usuario.identificacion,
        }
      );

      await muestraDatosCursosCertificados(
        cursoSeleccionado,
        {
          page: 1,
          todo: traerTodosCursantes,
        }
      );

      await Swal.fire({
        icon: "success",
        title: "Operación realizada",
        text: "Los cursantes fueron vaciados correctamente.",
      });
    } catch (error) {
      console.error(
        "Error al vaciar cursantes:",
        error
      );

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: obtenerMensajeError(
          error,
          "No se pudo vaciar la tabla."
        ),
      });
    } finally {
      setModalCargando(false);
    }
  };

  const closeModalNuevoCertificado = () => {
    setModalNuevoCertificadoIsOpen(false);

    muestraCursosCertificados({
      page: 1,
      todo: traerTodosCursos,
    });
  };

  const closeModalEditoCertificado = () => {
    setModalEditoCertificadoIsOpen(false);
    setMuestroNominaCursantesCursos(false);

    muestraCursosCertificados({
      page: paginaCursos,
      todo: traerTodosCursos,
    });
  };

  const cerreMasivo = () => {
    setVeoCargaMasiva(false);

    muestraDatosCursosCertificados(
      cursoSeleccionado,
      {
        page: 1,
        todo: traerTodosCursantes,
      }
    );

    muestraCursosCertificados({
      page: paginaCursos,
      todo: traerTodosCursos,
    });
  };

  const cerrarSeleccionCurso = () => {
    setMuestroNominaCursantesCursos(false);
    setCursoSeleccionado({});
    setNominaCursantes([]);
    setVeoCargaMasiva(false);

    setPaginaCursantes(1);
    setTotalPaginasCursantes(1);
    setTotalCursantes(0);
    setTraerTodosCursantes(false);
    setHaySiguienteCursantes(false);
  };

  const modalHeader = (titulo, onClose) => (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        padding: "16px 20px",
        backgroundColor: "#0f172a",
        color: "#ffffff",
      }}
    >
      <h4
        style={{
          margin: 0,
          fontWeight: 700,
        }}
      >
        {titulo}
      </h4>

      <button
        type="button"
        className="btn btn-outline-light btn-sm"
        onClick={onClose}
      >
        Cerrar
      </button>
    </div>
  );

  const controlesPaginacion = ({
    pagina,
    totalPaginas,
    totalRegistros,
    traerTodos,
    cantidadMostrada,
    haySiguiente,
    onAnterior,
    onSiguiente,
    onTraerTodo,
    onTraer200,
  }) => (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        marginTop: "12px",
        padding: "12px",
        borderRadius: "10px",
        backgroundColor: "#f8fafc",
        border: "1px solid #e2e8f0",
      }}
    >
      <div>
        <strong>
          {traerTodos
            ? `Mostrando todos: ${cantidadMostrada}`
            : totalRegistros > cantidadMostrada
              ? `Mostrando ${cantidadMostrada} de ${totalRegistros}`
              : `Mostrando ${cantidadMostrada} registros`}
        </strong>

        {!traerTodos && (
          <div
            style={{
              color: "#64748b",
              fontSize: "0.85rem",
            }}
          >
            Página {pagina}
            {totalPaginas > 1
              ? ` de ${totalPaginas}`
              : ""}
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
        }}
      >
        {!traerTodos && (
          <>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={onAnterior}
              disabled={pagina <= 1}
            >
              Anterior
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={onSiguiente}
              disabled={!haySiguiente}
            >
              Siguiente
            </button>
          </>
        )}

        {!traerTodos ? (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={onTraerTodo}
          >
            Traer todo
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={onTraer200}
          >
            Volver a 200
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Modal
        isOpen={
          modalNuevoCertificadoIsOpen
        }
        onRequestClose={
          closeModalNuevoCertificado
        }
        style={customStyles}
        ariaHideApp={false}
      >
        {modalHeader(
          "Creación de certificaciones",
          closeModalNuevoCertificado
        )}

        <div style={{ padding: "20px" }}>
          {comprueboPermisos(
            Usuario.funcion,
            "Titulos"
          ) &&
            comprueboPermisos(
              Usuario.funcion,
              "Certificados"
            ) ? (
            <div
              style={{
                display: "grid",
                gap: "24px",
              }}
            >
              <section>
                <h5
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Nuevo certificado de curso
                </h5>

                <FormNuevoCertificado2
                  myID={
                    closeModalNuevoCertificado
                  }
                  cursos={cursosDisponibles}
                />
              </section>

              <hr />

              <section>
                <h5
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Nuevo título
                </h5>

                <FormNuevoCertificadoTitulos
                  myID={
                    closeModalNuevoCertificado
                  }
                  cursos={cursosDisponibles}
                />
              </section>
            </div>
          ) : null}

          {comprueboPermisos(
            Usuario.funcion,
            "Certificados"
          ) &&
            !comprueboPermisos(
              Usuario.funcion,
              "Titulos"
            ) ? (
            <FormNuevoCertificado2
              cursos={cursosDisponibles}
              myID={
                closeModalNuevoCertificado
              }
            />
          ) : null}

          {comprueboPermisos(
            Usuario.funcion,
            "Titulos"
          ) &&
            !comprueboPermisos(
              Usuario.funcion,
              "Certificados"
            ) ? (
            <FormNuevoCertificadoTitulos
              cursos={cursosDisponibles}
              myID={
                closeModalNuevoCertificado
              }
            />
          ) : null}
        </div>
      </Modal>

      <ModalOUR
        isOpen={modalCargando}
        onRequestClose={() =>
          setModalCargando(false)
        }
        style={customStyles2}
        ariaHideApp={false}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "8px",
          }}
        >
          <Spinner size="sm" />
          <span>
            Cargando información...
          </span>
        </div>
      </ModalOUR>

      <Modal
        isOpen={
          modalEditoCertificadoIsOpen
        }
        onRequestClose={
          closeModalEditoCertificado
        }
        style={customStyles}
        ariaHideApp={false}
      >
        {modalHeader(
          "Edición de certificación",
          closeModalEditoCertificado
        )}

        <div style={{ padding: "20px" }}>
          {comprueboPermisos(
            Usuario.funcion,
            "Titulos"
          ) ? (
            <FormEditoCertificadoTitulo
              cursoEditar={
                cursoSeleccionado
              }
              myID={
                closeModalEditoCertificado
              }
            />
          ) : null}

          {comprueboPermisos(
            Usuario.funcion,
            "Certificados"
          ) ? (
            <FormEditoCertificado2
              cursoEditar={
                cursoSeleccionado
              }
              myID={
                closeModalEditoCertificado
              }
            />
          ) : null}
        </div>
      </Modal>

      <main
        style={{
          minHeight: "100vh",
          backgroundColor: "#f1f5f9",
          padding: "18px",
        }}
      >
        <section
          style={{
            maxWidth: "1500px",
            margin: "0 auto",
          }}
        >
          <header
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent:
                "space-between",
              alignItems: "center",
              gap: "14px",
              padding: "20px",
              borderRadius: "16px",
              backgroundColor: "#0f3d73",
              color: "#ffffff",
              boxShadow:
                "0 8px 24px rgba(15, 61, 115, 0.20)",
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontWeight: 800,
                }}
              >
                Gestión de Certificaciones
              </h2>

              <div
                style={{
                  marginTop: "5px",
                  opacity: 0.88,
                }}
              >
                Usuario:{" "}
                <strong>
                  {Usuario?.nombre ||
                    Usuario?.identificacion}
                </strong>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <button
                type="button"
                className="btn btn-light"
                onClick={volver}
              >
                Volver
              </button>

              <button
                type="button"
                className="btn btn-warning"
                onClick={
                  crearCertificadoCurso
                }
              >
                Crear certificación
              </button>
            </div>
          </header>

          <section
            style={{
              marginTop: "18px",
              padding: "18px",
              borderRadius: "16px",
              backgroundColor: "#ffffff",
              boxShadow:
                "0 4px 18px rgba(15, 23, 42, 0.08)",
            }}
          >
            <div
              style={{
                marginBottom: "12px",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontWeight: 750,
                }}
              >
                Certificaciones disponibles
              </h4>

              <small
                style={{
                  color: "#64748b",
                }}
              >
                Ordenadas desde la más nueva
                hasta la más antigua.
              </small>
            </div>

            {!muestroCursos ? (
              <div
                style={{
                  padding: "30px",
                  textAlign: "center",
                  color: "#64748b",
                }}
              >
                Cargando certificaciones...
              </div>
            ) : cursosDisponibles.length >
              0 ? (
              <>
                <DevuelveCursos
                  cosas={
                    cursosDisponibles
                  }
                  myID={
                    muestraDatosCursosCertificados
                  }
                />

                {controlesPaginacion({
                  pagina: paginaCursos,
                  totalPaginas:
                    totalPaginasCursos,
                  totalRegistros:
                    totalCursos,
                  traerTodos:
                    traerTodosCursos,
                  cantidadMostrada:
                    cursosDisponibles.length,
                  haySiguiente:
                    haySiguienteCursos,
                  onAnterior: () =>
                    cambiarPaginaCursos(
                      paginaCursos - 1
                    ),
                  onSiguiente: () =>
                    cambiarPaginaCursos(
                      paginaCursos + 1
                    ),
                  onTraerTodo: () =>
                    cambiarModoCursos(true),
                  onTraer200: () =>
                    cambiarModoCursos(false),
                })}
              </>
            ) : (
              <div
                style={{
                  padding: "32px",
                  textAlign: "center",
                  color: "#64748b",
                }}
              >
                No hay certificaciones
                disponibles.
              </div>
            )}
          </section>

          {muestroNominaCursantesCursos && (
            <section
              style={{
                marginTop: "18px",
                padding: "18px",
                borderRadius: "16px",
                backgroundColor: "#ffffff",
                boxShadow:
                  "0 4px 18px rgba(15, 23, 42, 0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent:
                    "space-between",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "16px",
                }}
              >
                <div>
                  <h4
                    style={{
                      margin: 0,
                      fontWeight: 750,
                    }}
                  >
                    {cursoSeleccionado?.tituloCertificado ||
                      "Certificación seleccionada"}
                  </h4>

                  <small
                    style={{
                      color: "#64748b",
                    }}
                  >
                    {traerTodosCursantes
                      ? `${nominaCursantes.length} certificados activos mostrados`
                      : `${nominaCursantes.length} de ${totalCursantes} certificados activos`}
                  </small>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={
                      cerrarSeleccionCurso
                    }
                  >
                    Cerrar
                  </button>

                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={editaCurso}
                  >
                    Editar
                  </button>

                  <button
                    type="button"
                    className="btn btn-info"
                    onClick={cambiaFecha}
                  >
                    Cambia Fecha
                  </button>

                  {comprueboPermisos(
                    Usuario.funcion,
                    "Vacio Cursantes"
                  ) && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={
                          vaciarCursantes
                        }
                      >
                        Vaciar cursantes
                      </button>
                    )}

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                      setVeoCargaMasiva(
                        (prev) => !prev
                      )
                    }
                  >
                    {veoCargaMasiva
                      ? "Ocultar carga"
                      : "Agregar cursantes"}
                  </button>
                </div>
              </div>

              {veoCargaMasiva && (
                <div
                  style={{
                    marginBottom: "18px",
                    padding: "16px",
                    borderRadius: "12px",
                    backgroundColor:
                      "#f8fafc",
                    border:
                      "1px solid #e2e8f0",
                  }}
                >
                  <CargaMasiva
                    myID={cerreMasivo}
                    ListaExistente={
                      nominaCursantes
                    }
                    cursoActual={
                      cursoSeleccionado
                    }
                  />
                </div>
              )}

              <DevuelveCertificados
                cosas={nominaCursantes}
                myID={imprimoCertificado}
                desactiva={
                  desactivaCertificado
                }
              />

              {controlesPaginacion({
                pagina: paginaCursantes,
                totalPaginas:
                  totalPaginasCursantes,
                totalRegistros:
                  totalCursantes,
                traerTodos:
                  traerTodosCursantes,
                cantidadMostrada:
                  nominaCursantes.length,
                haySiguiente:
                  haySiguienteCursantes,
                onAnterior: () =>
                  cambiarPaginaCursantes(
                    paginaCursantes - 1
                  ),
                onSiguiente: () =>
                  cambiarPaginaCursantes(
                    paginaCursantes + 1
                  ),
                onTraerTodo: () =>
                  cambiarModoCursantes(true),
                onTraer200: () =>
                  cambiarModoCursantes(false),
              })}
            </section>
          )}
        </section>
      </main>
    </>
  );
}

export default Certificados;